<div class="img-wrapper">
  <div class="navigation">
    <div class="chips">
      <mat-chip-list aria-orientation="vertical">
        <mat-chip>{{ title }}</mat-chip>
        <mat-chip *ngIf="limit == 1; else notLimited">max. 1</mat-chip>
        <ng-template #notLimited>
          <mat-chip
            >{{ currentImage.index + 1 }}/{{ sliderPhotos.length }}</mat-chip
          >
        </ng-template>
      </mat-chip-list>
    </div>
    <div
      [hidden]="hidePrevious"
      #backButton
      (click)="navigateImage(-1)"
      class="circle"
    >
      <mat-icon>chevron_left</mat-icon>
    </div>
    <div
      [hidden]="hideNext"
      #forwardButton
      (click)="navigateImage(1)"
      class="circle"
    >
      <mat-icon>chevron_right</mat-icon>
    </div>
    <div class="circle" (click)="closeViewer()">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </div>
  </div>
  <img
    (swipe)="onSwipe($event)"
    class="img-src"
    [src]="transform(currentImage.data.url)"
  />
</div>
